import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { RequiredFieldsNoteComponent } from './required-fields-note.component';

export { RequiredFieldsNoteDirective } from './required-fields-note.directive';
export { RequiredFieldsNoteComponent } from './required-fields-note.component';
export { RequiredFieldsNoteModule } from './required-fields-note.module';

export const ngxRequiredFieldsNoteModule = angular.module('ngxRequiredFieldsNoteModule', [])
	.directive('ngxRequiredFieldsNote', downgradeComponent({ component: RequiredFieldsNoteComponent }))
	.name;
